<script>

  import {includes_array} from "./helpers";
  import _ from 'lodash';
  export default {
    name: 'CombinationHelper',
    methods: {
      correct_adults(adults, kid_ages, kid_age){
        if (kid_ages === undefined) return [adults, kid_ages];
        let new_ages = [];
        _.each(kid_ages, (age) => {
          if (age === undefined || age < kid_age) {
            new_ages.push(age);
          } else {
            adults += 1;
          }
        });
        return [adults, new_ages]
      },

      // возвращает комбинации распределенные по группам и отсортированные по весу групп
      make_groups(placements, hotel_groups, adults_count, ages_arr, kid_age) {
        console.log("======= make_groups! from:", placements, hotel_groups);
        let [adults, kids] = this.correct_adults(adults_count, ages_arr, kid_age);
        kids = kids.length;
        let groups = [],
            group_of_placements;
        console.log(hotel_groups);
        if (hotel_groups && hotel_groups.length > 0) {
          _.each(hotel_groups, (hg) => {
            console.log("!!! HOTEL GROUP: ", hg.name, hg.main);
            // получаем размещения конкретной группы
            group_of_placements = _.filter(placements, (el) => {
              return el.attributes.group_id === hg.id;
            });
            console.log("--- PLACEMENTS: ", group_of_placements.length);
            groups.push({
              group: hg,
              combinations: this.make_combinations(group_of_placements, undefined, adults, kids),
            })
          });
          groups = _.sortBy(groups, 'group.weight');
        }
        console.log("====== make_groups finished!");
        return groups
      },

      // преобразует комбинацию в массив с ID вместо объекта размещения.
      combo_to_info(combo){
        return _.map(combo, (el) => {
          return {id: Number(el.placement.id), quantity: el.quantity}
        });
      },


      // запускает генерацию комбинаций и помечает комбинацию если она есть в брони.
      // stored_combos_info - массив вида
      // [{id: 123, quantity: 1},{...}]
      // где 123 это id размещения в комбинации
      // используется для проверки, является ли данная комбинация уже выбранной для брони (booking)
      make_combinations(placements, stored_combos_info, adults, kids) {
        // console.log('make combinations for hotel group: ', placements.length, adults, kids);
        if (stored_combos_info === undefined) {stored_combos_info = []}
        let arr = [];
        _.each(this.generate_combinations(placements, adults, kids), (combo) => {
          let objs = combo;
          ////////////////////////////////
          // эта фича нужна для проверки сохраненных в бронировании комбинаций.
          // в данный момент это нужно только в заказе в CRM - но там свой код..
          // сейчас это возвращает false
          let selected = includes_array(
              stored_combos_info,
              objs
          );
          ////////////////////////////////
          arr.push({
            placements: combo,
            price: this.combination_price(combo),
            selected: selected,
          });
        });
        console.log('--- COMBINATIONS:', arr.length );
        return this.sort_by_combo_price(arr);
      },



      // сортирует массив по стоимости комбинации и возвращает его
      sort_by_combo_price(arr){
        return _.orderBy(arr, ['price'], ['asc']);
      },



      // Генерирует комбинации
      generate_combinations(placements, adults, kids) {
        let combos = [],
            combo = {},
            i1 = 0,
            i2 = 0,
            p1,p2,
            to1 = placements.length,
            to2 = placements.length;

        if (to1 !== undefined) {
          // перебираем комбинации в 2х циклах
          // (в этом случае возможно составить комбинацию только из 2х разных размещений)
          for(i1=0; i1 < to1; i1++) {
            for(i2=i1; i2 < to2; i2++) {
              p1 = placements[i1];
              p2 = placements[i2];
              combo = this.calc_quantity( p1, p2, adults, kids);
              if (combo) { combos.push(combo) }
            }
          }
        } else {
          console.error('Placements empty.')
        }
        return combos;
      },



      // Calculating and returns summary price for combination
      combination_price(combo){
        let prices = _.map(combo, (el)=> {return el.placement.attributes.price_by_course * el.quantity});
        return _.sum(prices);
      },



      // Возвращает объект с общим количеством туристов в комбинации
      combo_sum(p1, q1, p2, q2) {
        let data = {
          adults: (p1.attributes.adults_total * q1) + (p2.attributes.adults_total * q2),
          kids: (p1.attributes.kids_total * q1) + (p2.attributes.kids_total * q2),
        }
        return data;
      },



      // returns combination of placements for this.localBooking params
      // [{placement: p1, quantity: q1}]
      // OR
      // [{placement: p1, quantity: q1}, {placement: p2, quantity: q2}]
      // OR
      // false
      calc_quantity(p1, p2, adults, kids) {
        // console.log('calc quantity:', p1, p2, adults, kids)
        if (typeof(kids) !== "number") {
          console.error('Expected kids is number but received', typeof(kids));
          return false;
        }
        let a = adults,
            k = kids,
            n = 0,
            q1 = 1,
            q2 = 1,
            step = 1,
            flag = true,
            flag2 = true,
            target_sum,
            combo = {};
            // sum = a + k;

        // поправка для варианта когда попалась пара одинаковых комбинаций.
        if (p1.id === p2.id) { q2 = 0 }

        while( flag2 && n < 10 ){
          n++;
          target_sum = this.combo_sum(p1,q1,p2,q2);
          // console.log("^^^", n, q1, q2, target_sum, p1, p2);

          // Проверяем не превышает ли текущая комбинация нужное количество туристов
          if (target_sum.adults > a || target_sum.kids > k) {
            // если превышает, и это минимальное количество в комбинации, то прерываем работу
            if (q1 === 1 && q2 === 1) {
              flag = false;
              flag2 = false; //break

              // если превышает, но это не минимальное количество, пробуем изменить количество размещений в комбинации
            } else {
              // если это первый шаг (увеличение количества)
              // то пробуем уменьшить количество первого размещения и увеличить количество второго
              if (step === 1) {
                //console.log("=== Change step to 2", step, q1, q2 );
                q1--;
                q2++;
                step = 2; // запоминаем что мы уже пробовали менять количество.
                // если превышает и уже пробовали менять количество, то прерываем работу
              } else {
                //console.log("=== FALSE - [", p1.attributes.adults_total, p1.attributes.kids_total, "] [", p2.attributes.adults_total, p2.attributes.kids_total, ']' );
                flag = false;
                flag2 = false; //break
              }
            }
            // если текущая комбинация не превышает нужное количество, проверяем дальше
          } else {
            // Если текущая комбинация подходит - прерываем цикл.
            if ((target_sum.adults === a) && (target_sum.kids === k)) {
              //console.log("=== TRUE - [", p1.attributes.adults_total, p1.attributes.kids_total, "] [", p2.attributes.adults_total, p2.attributes.kids_total, ']' );
              flag2 = false; // break;

              // если текущая комбинация размещает меньше туристов чем нам нужно,
              // увеличиваем количество размещений в комбинации
            } else {
              // увеличиваем количество размещений в первой комбинации, если это первый этап увеличения количества.
              // если второй этап - увеличиваем количество второго размещения.
              step === 1 ? q1++ : q2++;
            }
          }
        }// end of while

        if (flag) {
          if (p1.id === p2.id) {
            combo = [{placement: p1, quantity: q1+q2}];
          } else {
            combo = [{placement: p1, quantity: q1}, {placement: p2, quantity: q2}];
          }
          console.log('Success.')
          return combo;
        } else {
          console.log('Fail.')
          return false;
        }
      },// end of calc_quantity



      find_equal_combo(combo, collection){
        let equal = undefined;
        _.each(collection, (el)=>{
          if (this.is_equal_combos(el, combo)) {
            equal = el;
          }
        });
        return equal;
      },



      is_equal_combos(combo1, combo2){
        let has_placement,  full_eq = true;
        _.each(combo1.placements, (p1)=>{
          has_placement = false;
          _.each(combo2.placements, (p2)=>{
            if ((p1.quantity === p2.quantity) && this.is_placements_equal(p1, p2)) {
              has_placement = true;
            }
          });
          if (!has_placement) { full_eq = false }
        });
        return full_eq;
      },



      is_placements_equal(tpp1, tpp2){
        tpp1 = tpp1.placement.attributes;
        tpp2 = tpp2.placement.attributes;
        let result = (
            (tpp1.adults     === tpp2.adults) &&
            (tpp1.adults_exb === tpp2.adults_exb) &&
            (tpp1.kids       === tpp2.kids) &&
            (tpp1.kids_exb   === tpp2.kids_exb) &&
            (tpp1.shared     === tpp2.shared)
        );
        return result;
      },



      find_combinations_for_group(group, combo_group){
        return _.find(combo_group, (el)=>{
          return (Number(el.group.id) === Number(group.id));
        });
      }
    }
  }
</script>